import React, { Component } from "react"
import Link from "gatsby-link"

export default class LanguageSelection extends Component {
  state = {
    currentLang: 'it'
  }

  itClick() {
    if (this.state.currentLang !== 'it') {
      window.location.replace(window.location.href.replace('/en', '/it'));
      this.setState({ currentLang: 'it' })
    }
  }

  enClick() {
    if (this.state.currentLang !== 'en') {
      window.location.replace(window.location.href.replace('/it', '/en'));
      this.setState({ currentLang: 'en' })
    }
  }

  componentDidMount() {
    this.setState({ currentLang: this.props.lang || 'it' })
  }

  render() {
    const { currentLang } = this.state;
    return (
      <div className="navbar-language">
        <img src="/it.svg" className={ currentLang != 'it' ? 'selectable' : '' } style={{ width: '27px' }} onClick={ this.itClick.bind(this) } />
        <img src="/en.svg" className={ currentLang != 'en' ? 'selectable' : '' } style={{ width: '30px', marginLeft: '10px' }} onClick={ this.enClick.bind(this) } />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/LanguageSelection.js